import {
  FETCH_ALL_ACCOUNTING_PROVIDERS,
} from './../../mutation-types';

export default {
  [FETCH_ALL_ACCOUNTING_PROVIDERS](state, types) {
    state.all = types;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/accountingProvider/mutations.js